import { Avatar, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { range } from "lodash-es";
import { PropsWithChildren } from "react";

import { useDevices } from "@dfp/react-mui-theme";

const rows = range(5);

const cells = [
  "some text",
  "avatar content",
  "color text",
  "text",
  "longer text",
  "avatar content 2",
];

type TableBlurOverlayProps = PropsWithChildren;

export function TableBlurOverlay({ children }: TableBlurOverlayProps) {
  const { isMobile } = useDevices();
  const displayCells = isMobile ? cells.slice(0, 2) : cells;

  return (
    <>
      <TableRow
        sx={({ palette }) => ({
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(10px)",
          zIndex: 1,
          borderTop: `1px solid ${palette.grey[50]}`,
        })}
      >
        {children}
      </TableRow>
      {rows.map((row) => (
        <TableRow key={row}>
          {displayCells.map((cell) => (
            <TableCell key={cell} sx={{ border: "none" }}>
              <Stack
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                  flexDirection: "row",
                }}
              >
                {cell.includes("avatar") ? (
                  <Avatar sx={(theme) => ({ ...theme.avatarSize[32] })}>
                    <Typography variant="body2">HN</Typography>
                  </Avatar>
                ) : null}
                <Typography
                  sx={({ palette }) => ({
                    color: cell.includes("color")
                      ? palette.success.main
                      : "text.secondary",
                  })}
                  variant="body1"
                >
                  {cell}
                </Typography>
              </Stack>
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
